import React from 'react';
import { supabase } from '../lib/supabaseClient';

// Signed in, but the email has no user_access row (or my_access() failed).
export default function NoAccess({ session, error }) {
  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Property Manager</h1>
        {error ? (
          <p>We couldn't load your access. Please try again in a moment.</p>
        ) : (
          <p>
            You're signed in as <strong>{session.user.email}</strong>, but this account doesn't have access to any
            property yet. Ask the property owner to add you.
          </p>
        )}
        <button className="btn btn-primary" onClick={() => supabase.auth.signOut()} style={{ width: '100%' }}>
          Sign Out
        </button>
      </div>
    </div>
  );
}
